import { ZERO } from "@utils/constants";
import { displayPrice } from "@utils/pricing";

export interface LineItemPriceProps {
  original: string | number;
  final: string | number;
  shadowPrices: boolean;
  zeroDisplay?: string;
}

const LineItemPrice = ({
  original,
  final,
  shadowPrices = false,
  zeroDisplay = ZERO,
}: LineItemPriceProps) => {
  const originalPrice = typeof original === "string" ? parseFloat(original) : original;
  const finalPrice = typeof final === "string" ? parseFloat(final) : final;
  const finalDisplayPrice = shadowPrices ? zeroDisplay : displayPrice(finalPrice);

  return (
    <span>
      {finalPrice < originalPrice ? (
        <>
          <s className="strikeout">{displayPrice(originalPrice)}</s>{" "}
          <span className="red">{finalPrice > 0 ? displayPrice(finalPrice) : zeroDisplay}</span>
        </>
      ) : (
        finalDisplayPrice
      )}
    </span>
  );
};

export default LineItemPrice;
